import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { FormControl, InputLabel, InputAdornment, ClickAwayListener, Tooltip, IconButton } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import EventIcon from '@material-ui/icons/Event'
import { lg } from '../utils/ResponsiveUtility'
import FlashOnIcon from '@material-ui/icons/FlashOn'
import EditIcon from '@material-ui/icons/Edit'
import InfoIcon from '@material-ui/icons/Info'

const FormDateField = ({
                         formActions, classes, name, labelKey, required, value, handleChange, format, disablePast, disableFuture, atts = {},
                         switchEdit, switchEditValue, handleSwitchEdit, info, infoKey, row, noClear
                       }) => {
  const intl = useIntl()
  const [width, setWidth] = React.useState(document.body.clientWidth)
  let Mobile = (width < lg)
  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])

  const [tooltipOpen, setTooltipOpen] = React.useState(false)
  const [editTooltipOpen, setEditTooltipOpen] = React.useState(false)

  const handleTooltipClose = () => {
    setTooltipOpen(false)
  }

  const ToggleTooltipOpen = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setTooltipOpen(!tooltipOpen)
  }

  const handleEditTooltipClose = () => {
    setEditTooltipOpen(false)
  }

  const handleEditTooltipOpen = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setEditTooltipOpen(true)
    handleSwitchEdit(!switchEditValue)
  }
  const editSwitch = {
    endAdornment: (
      <InputAdornment position="end">
        {!!Mobile ?
          <ClickAwayListener onClickAway={handleEditTooltipClose}>
        <span><Tooltip
          open={editTooltipOpen}
          onClose={handleEditTooltipClose}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={intl.formatMessage({ id: `SwitchEdit.${!!switchEditValue}` })}
          arrow>
          <IconButton size={'small'} color={'primary'}
                      onClick={handleEditTooltipOpen}
                      onMouseDown={handleEditTooltipOpen}
          >
            {!!switchEditValue ? <FlashOnIcon/> : <EditIcon/>}
          </IconButton>
        </Tooltip></span>
          </ClickAwayListener>
          :
          <Tooltip title={intl.formatMessage({ id: `SwitchEdit.${!!switchEditValue}` })} arrow>
            <IconButton size={'small'} color={'primary'}
                        onClick={() => handleSwitchEdit(!switchEditValue)}
                        onMouseDown={() => handleSwitchEdit(!switchEditValue)}
            >
              {!!switchEditValue ? <FlashOnIcon/> : <EditIcon/>}
            </IconButton>
          </Tooltip>
        }
      </InputAdornment>
    )
  }
  return (
    <div className={classes.FormItem + ` ${!!row ? classes.FormRow : ''}`}>
      <InputLabel htmlFor={name}><FormattedMessage id={labelKey}/>{!!required &&
      <span className={'required'}>*</span>}: {!!info && (!!Mobile ?
        <ClickAwayListener onClickAway={handleTooltipClose}>
        <span><Tooltip
          PopperProps={{
            disablePortal: true
          }}
          open={tooltipOpen}
          onClose={handleTooltipClose}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={intl.formatMessage({ id: infoKey })}
          arrow>
        <InfoIcon onClick={ToggleTooltipOpen}/>
        </Tooltip></span>
        </ClickAwayListener> : <Tooltip
          title={intl.formatMessage({ id: infoKey })} arrow><InfoIcon/></Tooltip>)
      }</InputLabel>
      <FormControl variant="outlined">
        <DatePicker
          autoOk
          fullWidth
          clearable={!noClear}
          required={required}
          value={value}
          id={name}
          name={name}
          disabled={!!switchEdit && !switchEditValue}
          disablePast={!!disablePast}
          disableFuture={!!disableFuture}
          margin="dense"
          variant="outlined"
          inputVariant="outlined"
          format={format ?? 'dd-MM-yyyy'}
          placeholder={intl.formatMessage({ id: labelKey })}
          InputProps={!!switchEdit ? {
            ...editSwitch,
            startAdornment:
              <InputAdornment position="start">
                <EventIcon/>
              </InputAdornment>
          } : {
            startAdornment:
              <InputAdornment position="start">
                <EventIcon/>
              </InputAdornment>
          }}
          onChange={handleChange}
          onBlur={formActions.handleBlur}
          helperText={formActions.errors[name] && formActions.touched[name] &&
          <FormattedMessage id='validationSchema.date'/>}
          error={formActions.errors[name] && formActions.touched[name] !== undefined}
          cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
          okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
          clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
          todayLabel={intl.formatMessage({ id: 'datePicker.today' })}
          showTodayButton
          {...atts}
        />
        {/*{formActions.errors[name] && formActions.touched[name] && (*/}
        {/*  <FormHelperText error={true}><FormattedMessage id='validationSchema.date'/></FormHelperText>*/}
        {/*)}*/}
      </FormControl>
    </div>
  )
}

export default FormDateField
